import { useCallback, useEffect, useState } from "react";
import { fetchParticipantContactLogs } from "../api/participantContactLogs";
import { useLatestRequestSeq } from "./useLatestRequestSeq";

/**
 * Load contact logs for one participant. `enabled` should be false when the modal is closed.
 */
export function useParticipantContactLogs({ accountId, participantUserId, enabled }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const beginRequest = useLatestRequestSeq();

  const reload = useCallback(async () => {
    const account_id = accountId != null ? String(accountId).trim() : "";
    const participant_user_id = participantUserId != null ? String(participantUserId).trim() : "";
    if (!enabled || !account_id || !participant_user_id) {
      setLogs([]);
      setLoading(false);
      return [];
    }
    const seq = beginRequest();
    setLoading(true);
    setError("");
    try {
      const rows = await fetchParticipantContactLogs({ account_id, participant_user_id });
      if (!seq.isCurrent()) return [];
      setLogs(rows);
      return rows;
    } catch (err) {
      if (!seq.isCurrent()) return [];
      const message = err && err.message ? String(err.message) : "Unable to load contact notes.";
      setError(message);
      setLogs([]);
      return [];
    } finally {
      if (seq.isCurrent()) setLoading(false);
    }
  }, [accountId, participantUserId, enabled, beginRequest]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { logs, loading, error, setError, reload, count: logs.length };
}
